import { render, staticRenderFns } from "./ImpersonationChrome.vue?vue&type=template&id=23aab5ba&scoped=true"
import script from "./ImpersonationChrome.vue?vue&type=script&lang=js"
export * from "./ImpersonationChrome.vue?vue&type=script&lang=js"
import style0 from "./ImpersonationChrome.vue?vue&type=style&index=0&id=23aab5ba&prod&scoped=true&lang=scss"
import style1 from "./ImpersonationChrome.vue?vue&type=style&index=1&id=23aab5ba&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23aab5ba",
  null
  
)

export default component.exports